module.exports = __webpack_public_path__ + "static/media/brand2.e96c5faa.png";